export function canCreateProximityContent(isChatDisabled: boolean): boolean {
    return !isChatDisabled;
}
